module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('div', {
    staticClass: "card card-default widget animated"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_c('div', {
    staticClass: "big-row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('form-text', {
    attrs: {
      "label": "Search Archived Workflow",
      "name": "searchworkflow"
    },
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  })], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('data-table', {
    attrs: {
      "data": _vm.filteredData,
      "columns": _vm.gridColumns,
      "filter-key": _vm.searchQuery
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-501858d8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operations/ArchivedWorkflows/ArchivedWorkflows.vue
// module id = 624
// module chunks = 1